import { FC } from 'react'
import { Collapse, CollapsePanelProps } from 'antd'
import classNames from 'classnames'

import style from './style.m.less'
import { Down } from '../../../assets/icons'

const { Panel: AntPanel } = Collapse

interface IPanelProps extends CollapsePanelProps {
    isSmall: boolean
}

const Panel: FC<IPanelProps> = (props) => {
    const realHeader = (
        <div
            className={classNames(
                style.header,
                { [style.active]: (props as any).isActive },
                { [style.small]: (props as any).isSmall },
            )}
        >
            {props.header}
            <span className={style.icon}>
                <Down />
            </span>
        </div>
    )
    return (
        <AntPanel
            showArrow={false}
            {...props}
            header={realHeader}
            className={classNames(style.panel, (props as any).className)}
        />
    )
}

export default Panel
